import { IOccurrence, OccurrenceStatus } from "../../../types";
import moment from "moment";

interface IFieldsToUpdate {
    responsible: string;
    dn: string;
    chassis: string;
    licensePlate: string;
    customer: string;
    dnResponsible: string;
    hourMeter: number;
    odometer: number;
    entryDate?: string;
    selectedUser: string[];
    selectedUserName?: string;
    selectedRegional?: string[];
    customerComment: string;
    diagnose: string;
    repair: string;
    analysisReason: string;
    partName: string;
    aeg: string;
    vehicleQtd?: number;
    cancelComment: string;
    partOrComponentName: string;
    partNumber: number;
    problemDescription: string;
    diagnosticAndResults: string;
    problemSteps: string;
    failureFrequency: string;
    phone: string;
    cancelReason: string;
    occurrenceId: string | null | undefined;
    subject: string;
    subtopic: string;
}

export const buildEditPayload = (
    currentData: IOccurrence, 
    status: OccurrenceStatus,
    fieldsToUpdate: IFieldsToUpdate,
) => ({
    ...currentData,
    responsible: fieldsToUpdate.responsible,
    dn: fieldsToUpdate.dn,
    chassis: fieldsToUpdate.chassis,
    licensePlate: fieldsToUpdate.licensePlate,
    customer: fieldsToUpdate.customer,
    dnResponsible: fieldsToUpdate.dnResponsible,
    hourMeter: fieldsToUpdate.hourMeter,
    odometer: fieldsToUpdate.odometer,
    entryDate: moment(fieldsToUpdate.entryDate).isValid() ? `${fieldsToUpdate.entryDate}T03:00:00Z` : null,
    statusUpdatedAt: currentData.status === status ? currentData.statusUpdatedAt : moment.utc().format("YYYY-MM-DDTHH:mm:ss.SSS[Z]"),
    status: status,
    assignedToId: fieldsToUpdate.selectedUser?.[0] || '',
    assignedTo: fieldsToUpdate.selectedUserName || '',
    regionalId: fieldsToUpdate.selectedRegional?.[0] ? Number(fieldsToUpdate.selectedRegional?.[0]) : null,
    customerComment: fieldsToUpdate.customerComment,
    diagnose: fieldsToUpdate.diagnose,
    repair: fieldsToUpdate.repair,
    analysisReason: fieldsToUpdate.analysisReason,
    partName: fieldsToUpdate.partName,
    aeg: fieldsToUpdate.aeg,
    vehicleQtd: Number(fieldsToUpdate.vehicleQtd) || 0,
    cancelComment: fieldsToUpdate.cancelComment,
    partOrComponentName: fieldsToUpdate.partOrComponentName,
    partNumber: Number(fieldsToUpdate.partNumber) || 0,
    problemDescription: fieldsToUpdate.problemDescription,
    diagnosticAndResults: fieldsToUpdate.diagnosticAndResults,
    problemSteps: fieldsToUpdate.problemSteps,
    failureFrequency: fieldsToUpdate.failureFrequency,
    phone: fieldsToUpdate.phone,
    cancelReason: fieldsToUpdate.cancelReason,
    mainOccurrenceId: fieldsToUpdate.occurrenceId,
    subject: fieldsToUpdate.subject,
    subtopic: fieldsToUpdate.subtopic,
});